import { render, staticRenderFns } from "./vUpsellModal.vue?vue&type=template&id=165e3728&scoped=true"
import script from "./vUpsellModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./vUpsellModal.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165e3728",
  null
  
)

export default component.exports